export const GIGYA_BRAND_IMAGE_FAVORITES = 'https://static.talparadio.nl/images/juke/favorite-login-register.jpg';
export const GIGYA_DEFAULT_JUKE_BRAND_IMAGE =
  'https://images.ctfassets.net/0w1d9hjfek5f/1l9yeXuVq0uQs02YGCmy2w/e65feef3218fd0c7862e868a7c72d33c/Juke.jpg';
export const AUDIO_HD_GIGYA_IMAGE = 'https://static.talparadio.nl/images/juke/hd-audio-login-register.png';
export const GIGYA_SCREENSET_MOBILE_VIEW_BREAKPOINT = 965;

export enum GIGYA_SCREENSET {
  REGISTRATION_LOGIN = 'TA_2021-RegistrationLogin',
  LOGIN_SCREEN = 'gigya-login-screen',
  REGISTER_SCREEN = 'gigya-register-screen',
  RESET_PASSWORD_SCREEN = 'gigya-reset-password-screen',
  VERIFICATION_PENDING = 'gigya-verification-pending-screen',
  PROFILE = 'TA_2021-ProfileUpdate',
  LITE_REGISTRATION = 'TA_2021-LiteRegistration',
}

export enum GIGYA_ACCOUNT_ACTION {
  LOGIN = 'login',
  ACTIVATION = 'activation',
  RESET_PASSWORD = 'reset-password',
  OPTIN = 'optin',
}

export const GIGYA_MODAL_MESSAGE = {
  DIALOG_TITLE_SUCCESS: 'Je hebt nu een JUKE Account!',
  DIALOG_TITLE_FAILED: 'JUKE Account',
  CONTENT_TITLE_SUCCESS: 'Log nu in bij JUKE',
  CONTENT_TITLE_FAILED: 'Aanmelden bij JUKE mislukt',
  TEXT_SUCCESS: `Je hebt met succes een account aangemaakt. Log nu in om jouw lievelingsradiostations 
  toe te voegen aan je favorieten of zodat automatisch wordt onthouden waar je bent gebleven in die spannende podcastaflevering. Veel luister plezier!`,
  TEXT_FAILED: 'Helaas is er iets niet goed gegaan bij je registratie voor een JUKE  account. Probeer het nogmaals.',
  BTN_SUCCESS: 'Log meteen in',
  BTN_FAILED: 'Sluit scherm',
};
